import { resolveWorksWithTools } from '@/lib/service-tool-logos'

/**
 * "Includes {logos}" row — shows tool logos for services that cover
 * multiple platforms (e.g. PPC Account Audit → Google Ads, Microsoft).
 * Renders nothing when the service has no tools set.
 */
export default function WorksWithLogos({
  toolIds,
  size = 'md',
  max = 5,
  label = 'Includes',
  className = '',
}: {
  toolIds: string[] | null | undefined
  size?: 'sm' | 'md' | 'lg'
  max?: number
  label?: string
  className?: string
}) {
  const tools = resolveWorksWithTools(toolIds)
  if (tools.length === 0) return null

  const visible = tools.slice(0, max)
  const overflow = tools.length - visible.length

  const sizeMap = {
    sm: { dims: 'h-5 w-5', px: 20, text: 'text-[11px]', gap: 'gap-1.5' },
    md: { dims: 'h-7 w-7', px: 28, text: 'text-xs', gap: 'gap-2' },
    lg: { dims: 'h-9 w-9', px: 36, text: 'text-sm', gap: 'gap-2.5' },
  } as const
  const { dims, px, text, gap } = sizeMap[size]

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className={`${text} font-medium text-slate-500`}>{label}</span>
      <div className={`flex items-center ${gap}`}>
        {visible.map((tool) => (
          <img
            key={tool.id}
            src={tool.logo}
            alt={tool.name}
            title={tool.name}
            width={px}
            height={px}
            className={`${dims} shrink-0 rounded-full border border-slate-200 bg-white object-contain p-0.5 shadow-sm`}
          />
        ))}
        {overflow > 0 && (
          <span
            className={`${dims} flex shrink-0 items-center justify-center rounded-full border border-slate-200 bg-slate-100 ${text} font-semibold text-slate-600 shadow-sm`}
          >
            +{overflow}
          </span>
        )}
      </div>
    </div>
  )
}
